import { render, staticRenderFns } from "./BudgetUsageBar.vue?vue&type=template&id=71a85a6e&scoped=true&"
import script from "./BudgetUsageBar.vue?vue&type=script&setup=true&lang=js&"
export * from "./BudgetUsageBar.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BudgetUsageBar.vue?vue&type=style&index=0&id=71a85a6e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a85a6e",
  null
  
)

export default component.exports